import { connect } from 'react-redux'
import RiderProfileEditPane from '../../components/riders/editrider/RiderProfileEditPane'
import * as actions from '../../state/actions/riders'
import history from '../../history'
import { IRiderObject, IStoreState } from '../../types'

export function mapStateToProps(state: IStoreState, ownProps: any): any {
  return {
    metadata: state.riders.metadata,
    riders: state.riders.items,
    loading: state.riders.isFetching
  }
}

export function mapDispatchToProps(dispatch: any) {
  return {
    getRiderPersonalInfo: (riderId: string): any => {
      return dispatch(actions.getRiderPersonalInfo(riderId))
    },
    moveToArchive: async (rider: IRiderObject) => {
      await dispatch(actions.archiveRider(rider))
      history.push('/riders')
    },
    activate: (rider: IRiderObject) => {
      dispatch(actions.activateRider(rider))
    },
    deactivate: (rider: IRiderObject) => {
      dispatch(actions.deactivateRider(rider))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RiderProfileEditPane)



// WEBPACK FOOTER //
// ./src/containers/riders/RiderProfileEditPane.ts